/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { LoginStatus } from '@s4l/stayforlong/auth/LoginStatus'
import { useCallback } from 'react'
import { showLoginModal } from '../browser/eventBridge'
import { useS4LContext } from '@s4l/react-context'

export function useRequireLogin<T extends any[]>(
  callback: (loginStatus: LoginStatus) => (...args: T) => void,
  source: string
): {
  callback: (...arg: T) => Promise<void>
} {
  const { domain } = useS4LContext()

  const innerCallback = useCallback(
    // eslint-disable-next-line consistent-return
    async (...args: T) => {
      const [error, loginStatus] = await domain.GetCurrentLoginStatusAuthUseCase.execute()

      if (error) {
        console.error(error)

        return
      }

      if (loginStatus.isUnlogged()) {
        showLoginModal(source)

        const handleLoginChanged = async () => {
          const [loginError, newLoginStatus] =
            await domain.GetCurrentLoginStatusAuthUseCase.execute()
          if (loginError) {
            console.error(loginError)

            return
          }

          if (newLoginStatus.isLogged()) {
            callback(newLoginStatus)(...args)
          }

          window.removeEventListener('login-change', handleLoginChanged)
        }

        window.addEventListener('login-change', handleLoginChanged)

        return
      }

      callback(loginStatus)(...args)
    },
    [callback, source, domain]
  )

  return {
    callback: innerCallback,
  }
}
